<template>
  <footer
    class="footer text-center"
    style="background-color: #1f1b1b !important; display: flex"
  >
    <div class="container text-center">
      <div class="copyright text-center" style="color: white !important">
        &copy; {{ new Date().getFullYear() }}
        <a style="color: white !important">All Rights Reserved</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
